<style lang="scss" src='./StationMap.scss' scoped></style>
<template src="./StationMap.html"></template>

<script>
import MapStation from '@/assets/img/ic/ico_marker_station.png';

export default {
  name: 'StationMap',
  props: {
    station: {
      required: false,
    },
  },
  data() {
    return ({
      map: {},
      google: {},
    });
  },
  computed: {
    valid() {
      if(this.station.longitude && this.station.latitude && this.G_validateLatLong(this.station.latitude, this.station.longitude)){
        return true
      }
      return false
    },
  },
  watch: {
    station: function (newStation, oldStation) {
      if (newStation && oldStation && newStation.station_id !== oldStation.station_id) {
        this.loadData();
      }
    }
  },
  methods: {

    async initMap({latitude, longitude}) {
      const position = {
        lat: latitude,
        lng: longitude
      };

      const mapOptions = {
        mapId: 'map',
        zoom: 18,
        center: position,
        controlOptions: {
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
        },
      };

      this.map = await this.G_initMap(mapOptions);
      this.google = this.consts.Google.MAP;

      const icon = {
        url: MapStation,
        scaledSize: new google.maps.Size(100, 75),
      }

      const newMark = new window.google.maps.Marker({
        position,
        icon,
      });

      if (this.map && this.google && this.google.maps) {
        newMark.setAnimation(this.google.maps.Animation.BOUNCE);
        newMark.setMap(this.map);

        // eslint-disable-next-line
        setTimeout(function () {
          newMark.setAnimation(null);
        }, 1500);
      }
    },

    async loadData() {
      if (this.station && this.station.latitude){
        if(this.G_validateLatLong(this.station.latitude, this.station.longitude)){
          this.initMap(this.station);
        }
      }else{
        this.map = await this.G_initMap({
          mapId: 'map',
          center: {
            lat: 0,
            lng: 0,
          },
          zoom: 2
        });
      }
    },

  },

  beforeCreate() {},

  created() {},

  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Stations Map");
      this.$analytics.logEvent("web_stations_map");
    }
    this.loadData();
  },
};
</script>
